import { RequestStatus, type WorkflowAction } from "@vv/requests-frontend";

/** Left-to-right column order - roughly the happy path, with the two
 * exception branches (rework, rejection) placed near where they occur. */
export const COLUMN_ORDER: RequestStatus[] = [
  RequestStatus.Submitted,
  RequestStatus.Assigned,
  RequestStatus.InProgress,
  RequestStatus.ReworkRequired,
  RequestStatus.Completed,
  RequestStatus.Rejected,
];

export const COLUMN_LABELS: Record<RequestStatus, string> = {
  [RequestStatus.Submitted]: "Submitted",
  [RequestStatus.Assigned]: "Assigned",
  [RequestStatus.Rejected]: "Rejected",
  [RequestStatus.InProgress]: "In Progress",
  [RequestStatus.Completed]: "Completed",
  [RequestStatus.ReworkRequired]: "Rework Required",
};

/**
 * Mirrors `VALID_TRANSITIONS` but names the action each edge maps to, since
 * dragging a card needs to know exactly which workflow action to invoke (and
 * which modal, if any, collects the data that action needs) - not just
 * whether the move is graph-valid.
 */
export const TRANSITION_ACTIONS: Partial<
  Record<RequestStatus, Partial<Record<RequestStatus, WorkflowAction>>>
> = {
  [RequestStatus.Submitted]: {
    [RequestStatus.Assigned]: "accept",
    [RequestStatus.Rejected]: "reject",
  },
  [RequestStatus.Assigned]: {
    [RequestStatus.InProgress]: "start",
  },
  [RequestStatus.InProgress]: {
    [RequestStatus.Completed]: "complete",
  },
  [RequestStatus.Completed]: {
    [RequestStatus.ReworkRequired]: "requestRework",
  },
  [RequestStatus.ReworkRequired]: {
    [RequestStatus.Assigned]: "approveRework",
    [RequestStatus.Completed]: "rejectRework",
  },
};

/** Actions that need a modal to collect extra data before the API call - the rest fire immediately on drop. */
export const MODAL_ACTIONS: ReadonlySet<WorkflowAction> = new Set([
  "reject",
  "accept",
  "complete",
  "requestRework",
  "approveRework",
]);
